import {EventType} from '@/views/timeline/services/events.types';

const DUMMY_EVENTS: EventType[] = [{
    location: 'Daimlerstraße 44, Ulm',
    customer: 'Nagel',
    description: 'Kran aufbauen und Sicherheitsprüfung durchführen',
    machines: [
        'Liebherr EC-H 140/6'
    ],
    style: 'background-color: #fefefe'
}, {
    location: 'Hans-Liebherr-Straße 45, Biberach',
    customer: 'Liebherr',
    description: 'Raupenbagger Wartung',
    machines: [
        'Liebherr R 914 Compact Litronic'
    ],
    style: 'background-color: #fefefe'
}, {
    location: 'Hans-Liebherr-Straße 45, Biberach',
    customer: 'Liebherr',
    description: 'Pumpe reinigen',
    machines: [
        'Liebherr R 914 Compact Litronic'
    ],
    style: 'background-color: #fefefe'
}, {
    location: 'Hans-Liebherr-Straße 45, Biberach',
    customer: 'Liebherr',
    description: 'Baumaschinen Wartung',
    machines: [
        'Liebherr R 914 Compact Litronic'
    ],
    style: 'background-color: #fefefe'
}, {
    location: 'Hans-Liebherr-Straße 45, Biberach',
    customer: 'Liebherr',
    description: 'Baumaschinen Inspektion',
    machines: [
        'Liebherr R 914 Compact Litronic'
    ],
    style: 'background-color: #fefefe'
}, {
    location: 'Hans-Liebherr-Straße 45, Biberach',
    customer: 'Liebherr',
    description: 'Bagger liefern',
    machines: [
        'Liebherr R 914 Compact Litronic'
    ],
    style: 'background-color: #fefefe'
}];

export {DUMMY_EVENTS};
